const PIXEL_ID = '888530810886885'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Standard Meta Pixel base code
  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the fbevents.js script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  // Initialize and fire PageView
  f.fbq('init', PIXEL_ID)
  f.fbq('track', 'PageView')
}

export function trackEvent(eventName: string, data?: Record<string, any>) {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', eventName, data)
  }
}
